import { ActionTypes } from '../actions';

const CartReducer = (state = true, action) => {
  switch (action.type) {
    case ActionTypes.CARTBUTTON:
      return action.payload;
    default:
      return state;
  }
};

export default CartReducer;
